import "./approach.css";

import React from "react";

import { APPROACH } from "../../data/content";
import SectionHeading from "../general/SectionHeading";

const Approach = () => {
  return (
    <section className={"section approach"}>
      <div className={"container"}>
        <SectionHeading
          tag={APPROACH.tag}
          title={APPROACH.title}
        />
      </div>

      {/* Runs from the content edge to the right of the screen, like the original */}
      <div className={"approach-panel"}>
        <p>{APPROACH.text}</p>
      </div>
    </section>
  );
};

export default Approach;
